"use client";

import {JSX, memo} from "react";

import {useSnapshot} from "valtio";

import {ButtonLike} from "@/shared/ui/buttons/button-like";
import {InfoCard} from "@/shared/ui/data-display/cards";

import type {VideoItem, VideoLibraryModelInstance} from "../video-library-list.model";
import type {VideoModalModelInstance} from "./video-modal.model";

import "./styles/video-library-card.scss";

// Valtio models - only used in client components, serialization check not applicable
interface VideoLibraryCardProps {
    item: VideoItem;
    libraryModel: VideoLibraryModelInstance;
    modalModel: VideoModalModelInstance;
}

export const VideoLibraryCard = memo(function VideoLibraryCard({item, libraryModel, modalModel}: VideoLibraryCardProps): JSX.Element {
    const snapshot = useSnapshot(libraryModel);
    const duration = libraryModel.getVideoDuration(item.url);

    const openModal = (): void => {
        modalModel.state.title = item.title;
        modalModel.state.url = item.url;
        modalModel.state.isOpen = true;
    };

    const handleLike = (): void => {
        libraryModel.incrementLike(item.id);
    };

    const handleDislike = (): void => {
        libraryModel.incrementDislike(item.id);
    };

    const currentLikes = libraryModel.currentLikes(item.id);
    const currentDislikes = libraryModel.currentDislikes(item.id);

    return (
        <div className="video-library-section__card" data-version={snapshot.uiVersion}>
            <InfoCard
                id={item.id}
                image={{src: item.image.src, alt: item.image.alt}}
                title={item.title}
                excerpt={item.description}
                url={item.url}
                linkDisabled
                badge={duration || item.duration}
                readMoreType="none"
                fluid
                onImageClick={openModal}
                onTitleClick={openModal}
            >
                <ButtonLike likes={currentLikes} dislikes={currentDislikes} onLikeClick={handleLike} onDislikeClick={handleDislike} />
            </InfoCard>
        </div>
    );
});
